import { BasePolyhavenAsset } from "./base";
import { PolyhavenAsset } from "../types";
import { ExternalAssetSource } from "../../../types";

export class Model3DAsset extends BasePolyhavenAsset {
  constructor(file: PolyhavenAsset, apiBaseUrl: string) {
    super(file, apiBaseUrl);
  }

  getMetadata() {
    return {
      status: 'ready', // PolyHaven assets are always ready
      date: '', // PolyHaven doesn't provide dates in the basic API
      size: 0, // Would need to fetch from download endpoint
      categories: this.asset.categories,
      tags: this.asset.tags,
      max_resolution: this.asset.max_resolution,
      providerId: ExternalAssetSource.Polyhaven,
      licence: 'PolyHaven-licence',
      licenceUrl: 'https://polyhaven.com/license',
    };
  }
}
